<main class="table-page table-page--fill" dir="rtl">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" aria-label="بازگشت" routerLink="/"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
      <div class="title-block">
        <h1 class="title">{{ bDailyEvent ? 'وقایع روزانه' : 'مدیریت وقایع' }}</h1>
        <span class="muted" *ngIf="!bDailyEvent && hasSearched">به‌روزرسانی خودکار هر ۳۰ ثانیه</span>
      </div>
      <div class="actions">
        <button id="filterToggle" class="btn btn-ghost" type="button" [disabled]="loading"
          [attr.aria-expanded]="filtersOpen" aria-controls="eventFilters" (click)="filtersOpen = !filtersOpen">
          <i class="fa fa-sliders" aria-hidden="true"></i> فیلتر
          <span class="badge show" *ngIf="activeFilterCount">{{ activeFilterCount | faNum }}</span>
          <i class="fa fa-chevron-down chev" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="collapsible" id="eventFilters" [class.collapsed]="!filtersOpen">
      <div class="collapsible-inner">
        <form class="filters" [formGroup]="eventModel" (ngSubmit)="search()">
          <fieldset class="field border-0 p-0 m-0" [disabled]="loading">
            <label class="field-label" for="eventDate">تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="false"
              [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'"
              [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true">
              <input id="eventDate" class="control" type="text" formControlName="strDate" readonly />
            </ng-persian-datepicker>
          </fieldset>
          <fieldset class="field border-0 p-0 m-0" [hidden]="bDailyEvent" [disabled]="loading">
            <label class="field-label" for="eventTime">ساعت</label>
            <div class="input-group clockpicker" #timePicker>
              <input id="eventTime" class="control" type="text" formControlName="strTime" autocomplete="off" />
              <span class="input-group-addon"><span class="glyphicon glyphicon-time"></span></span>
            </div>
          </fieldset>
          <fieldset class="field border-0 p-0 m-0" [disabled]="loading">
            <label class="field-label" for="eventDomain">حوزه خدمت</label>
            <select id="eventDomain" class="control" formControlName="iMobileDomain" (change)="!bDailyEvent && refreshTable(true)">
              <option value="-1">همه حوزه‌های خدمت</option>
              <option *ngFor="let item of domain" [value]="item.iMobileDomain">{{ item.strComment }}</option>
            </select>
          </fieldset>
          <fieldset class="field border-0 p-0 m-0" [disabled]="loading">
            <label class="field-label" for="eventType">نوع واقعه</label>
            <select id="eventType" class="control" formControlName="tiJournalType" (change)="!bDailyEvent && refreshTable(true)">
              <option value="-1">همه وقایع</option>
              <option *ngFor="let item of journalTypeData" [value]="item.tiJournalType">{{ item.strComment }}</option>
            </select>
          </fieldset>
          <div class="filter-actions">
            <button class="btn btn-primary" type="submit" [disabled]="loading"><i class="fa fa-search" aria-hidden="true"></i> جستجو</button>
            <button class="btn btn-ghost" type="button" *ngIf="hasActiveFilters" [disabled]="loading" (click)="clearFilters()">
              <i class="fa fa-undo" aria-hidden="true"></i> حذف فیلترها
            </button>
          </div>
        </form>
      </div>
    </div>
  </header>

  <section class="card" aria-label="فهرست وقایع">
    <div class="table-toolbar">
      <div class="search-wrap">
        <input class="control" type="search" [disabled]="loading" [(ngModel)]="searchText" (ngModelChange)="refreshTable(true)"
          aria-label="جستجو در جدول وقایع" placeholder="جستجو در جدول: نام راننده، موبایل، پلاک، نوع واقعه، حوزه خدمت..." />
        <i class="fa fa-search" aria-hidden="true"></i>
      </div>
      <div class="toolbar-actions">
        <button class="btn btn-soft" type="button" [disabled]="loading || hasError || !EventsData.length" (click)="exportexcel()">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i> خروجی اکسل
        </button>
      </div>
    </div>
    <div class="body" [attr.aria-busy]="loading">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite">
        <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
      </div>
      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && !EventsData.length">
        <div class="ico-big"><i class="fa fa-inbox" aria-hidden="true"></i></div>
        <h4>{{ !hasSearched ? 'برای نمایش وقایع، جستجو کنید' : hasActiveFilters ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'واقعه‌ای در این بازه ثبت نشده است' }}</h4>
        <span class="muted" *ngIf="!hasSearched">تاریخ و فیلترهای موردنظر را انتخاب و دکمهٔ جستجو را بزنید.</span>
        <div class="empty-actions" *ngIf="hasSearched && hasActiveFilters">
          <button class="btn btn-ghost" type="button" (click)="clearFilters()"><i class="fa fa-undo" aria-hidden="true"></i> حذف فیلترها</button>
          <button class="btn btn-ghost" type="button" (click)="filtersOpen = true">تغییر فیلترها</button>
        </div>
      </div>
      <div class="state error" id="stError" [class.show]="!loading && hasError" role="alert">
        <div class="ico-big"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4><span class="muted">{{ errorMessage }}</span>
        <button class="btn btn-primary retry" type="button" (click)="getEventsData()"><i class="fa fa-refresh" aria-hidden="true"></i> تلاش مجدد</button>
      </div>
      <div class="table-scroll" id="tableWrap">
        <table aria-label="جدول وقایع">
          <thead id="thead">
            <tr>
              <th *ngIf="!bDailyEvent" class="col-ops sticky-first">عملیات</th>
              <th class="col-num">ردیف</th>
              <ng-container *ngIf="!bDailyEvent; else dailyHeaders">
                <th data-key="strDate" tabindex="0" [class.sorted]="dateSort" (click)="!loading && sortByDate()" (keydown.enter)="!loading && sortByDate()"
                  (keydown.space)="$event.preventDefault(); !loading && sortByDate()"
                  [attr.aria-sort]="dateSort === 'asc' ? 'ascending' : dateSort === 'desc' ? 'descending' : 'none'">
                  <span class="th-in">تاریخ<i class="fa sort-ico" [ngClass]="dateSort === 'asc' ? 'fa-sort-asc' : dateSort === 'desc' ? 'fa-sort-desc' : 'fa-sort'" aria-hidden="true"></i></span>
                </th>
                <th>ساعت</th><th>نوع واقعه</th><th>نام راننده</th><th>موبایل راننده</th><th>پلاک</th>
                <th>حوزه خدمت</th><th>نوع خودرو</th><th>توضیحات</th>
              </ng-container>
              <ng-template #dailyHeaders>
                <th>نوع خودرو</th><th>نام راننده</th><th>موبایل راننده</th><th>پلاک</th><th>حوزه خدمت</th><th>تخلف</th><th>تعداد</th>
              </ng-template>
            </tr>
          </thead>
          <tbody id="tbody">
            <tr *ngFor="let item of pagedRows; let i = index">
              <td *ngIf="!bDailyEvent" class="col-ops sticky-first">
                <div class="row-ops">
                  <button class="ico" type="button" aria-label="نمایش موقعیت روی نقشه" [disabled]="loading || !item.fLat || !item.fLon"
                    (click)="tips.hide(); openMap(item)" (mouseenter)="tips.show($event, 'نمایش روی نقشه')" (mouseleave)="tips.hide()"
                    (focus)="tips.show($event, 'نمایش روی نقشه')" (blur)="tips.hide()">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td class="col-num">{{ (currentPage - 1) * pageSize + i + 1 | faNum }}</td>
              <ng-container *ngIf="!bDailyEvent; else dailyCells">
                <td>{{ item.strDate | faNum }}</td><td>{{ item.strTime | faNum }}</td><td>{{ item.strJournalType_strComment }}</td>
                <td>{{ item.strFullName }}</td><td>{{ item.strMobile | faNum }}</td><td>{{ item.strVehicleNo | faNum }}</td>
                <td>{{ item.strMobileDomain_strComment }}</td><td>{{ item.strMobileGroup_strComment }}</td><td>{{ item.strComment }}</td>
              </ng-container>
              <ng-template #dailyCells>
                <td>{{ item.strMobileType_strComment }}</td><td>{{ item.strFullName }}</td><td>{{ item.strMobile | faNum }}</td>
                <td>{{ item.strVehicleNo | faNum }}</td><td>{{ item.strMobileDomain_strComment }}</td><td>{{ item.strJournalType_strComment }}</td>
                <td>{{ item.iCount | number | faNum }}</td>
              </ng-template>
            </tr>
          </tbody>
          <tfoot *ngIf="!loading && !hasError && EventsData.length">
            <tr><td *ngIf="!bDailyEvent" class="sticky-first"></td>
              <td class="label" [attr.colspan]="bDailyEvent ? 8 : 10">تعداد کل: {{ EventsData.length | number | faNum }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="EventsData.length"
      (pageChange)="changePage($event)" (pageSizeChange)="changePageSize($event)">
    </app-table-pagination>
  </section>
  <app-table-tooltip #tips></app-table-tooltip>
</main>

<div class="modal fade rtl" id="eventMapModal" #mapModal tabindex="-1" aria-labelledby="eventMapTitle" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="eventMapTitle">موقعیت واقعه روی نقشه</h5>
        <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="بستن"></button>
      </div>
      <div class="modal-body d-flex">
        <div class="position-relative w-100 flex-grow-1" #mapTarget aria-label="نقشه موقعیت واقعه" tabindex="0">
          <div class="position-absolute" id="eventMapTooltip" data-bs-html="true"></div>
        </div>
      </div>
      <div class="modal-footer"><button class="btn btn-ghost" type="button" data-bs-dismiss="modal">بستن</button></div>
    </div>
  </div>
</div>
